import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Alert,
    CircularProgress,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../auth/AuthContext';
import { extractApiErrorMessage } from '../api/httpClient';

export default function ReauthDialog({ open, onClose, onReauthSuccess }) {
    const { user, reauthenticate } = useAuth();
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (!password || !user?.email) return;

        setLoading(true);
        setError('');

        try {
            await reauthenticate(password);

            setPassword('');
            if (onReauthSuccess) {
                onReauthSuccess();
            }
            if (onClose) {
                onClose();
            }
        } catch (err) {
            setError(extractApiErrorMessage(err, 'Contraseña incorrecta. Verificá tus credenciales.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={() => {
                // Permitir cerrar para seguir trabajando offline
                if (onClose) onClose();
            }}
            maxWidth="xs"
            fullWidth
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LockOutlinedIcon color="warning" />
                    Sesión de red vencida
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Tu credencial de red expiró. Tus cambios pendientes se conservan de forma segura en este dispositivo hasta que reautentiques la conexión con el servidor.
                    </DialogContentText>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <TextField
                        autoFocus
                        label="Contraseña"
                        type="password"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={loading}
                        required
                        size="small"
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={() => {
                            if (onClose) onClose();
                        }}
                        disabled={loading}
                        color="inherit"
                    >
                        Continuar Offline
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loading || !password}
                    >
                        {loading ? <CircularProgress size={20} color="inherit" /> : 'Sincronizar'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
